/* eslint-disable @typescript-eslint/no-use-before-define */
import React from 'react';

// Material
import Grid from '@material-ui/core/Grid';

// Constants
import CONST_IMAGES from 'constants/images';

// Styles
import useStyles from './tablePlaceholder.styles';

interface TablePlaceholderProps {
  onClick?: () => void;
}

type Props = TablePlaceholderProps;

const TablePlaceholder: React.FC<Props> = ({ onClick }) => {
  const classes = useStyles();

  return (
    <Grid
      container
      direction='column'
      justifyContent='center'
      alignItems='center'>
      <Grid item onClick={onClick}>
        <img
          height={370}
          draggable={false}
          alt='Tabela Oculta'
          className={classes.image}
          src={CONST_IMAGES.PLACEHOLDER_IMAGES.ASTRONAUT}
        />
      </Grid>
      <Grid item onClick={onClick}>
        <span className={classes.text}>clique aqui para carregar os dados</span>
      </Grid>
    </Grid>
  );
};

export { TablePlaceholder };
export default TablePlaceholder;
